export const de = {
    REQUIRED_ACTION_KeepCapturing: 'Halte das Festhalten fest.',
    REQUIRED_ACTION_PauseCapturing: 'Pause Aufnahme',
    REQUIRED_ACTION_Close: 'Schließen',
    REQUIRED_ACTION_Error: 'Fehler',
    REQUIRED_ACTION_AGREE: 'Zustimmen',
    REQUIRED_ACTION_DISAGREE: 'Ablehnen',
    LIVENESS_ACTION_Smile: 'Lächeln',
    LIVENESS_ACTION_Frown: 'Stirnrunzeln',
    'LIVENESS_ACTION_Tilt Left': 'Schau nach links.',
    'LIVENESS_ACTION_Tilt Right': 'Schau nach rechts.',
    'LIVENESS_ACTION_Tilt Up': 'Schau nach oben.',
    'LIVENESS_ACTION_Tilt Down': 'Schau nach unten.',
    'LIVENESS_ACTION_Look Straight': 'Schau geradeaus.',
    'LIVENESS_ACTION_No Action': 'Keine Aktion',
    LIVENESS_ACTION_PROCESSING_LIVENESS: 'Verarbeitung der Lebendigkeit',
    'LIVENESS_RESULT_Thank you!.Failed': 'Gescheitert',
    'LIVENESS_RESULT_Thank you!.Passed': 'Bestanden',
    'LIVENESS_RESULT_Thank you!.ActionTimedOut': 'Aktion abgelaufen',
    'LIVENESS_RESULT_Thank you!.Interrupted': 'Unterbrochen',
    'LIVENESS_RESULT_Thank you!.Undefined': 'Undefiniert',
    LIVENESS_ACTION_LOOK_STRAIGHT_TITLE: 'Schauen Sie geradeaus',
    LIVENESS_ACTION_LOOK_STRAIGHT_TEXT:
        'Behalten Sie Ihre Augen immer auf dem Bildschirm',
    LIVENESS_ACTION_LOOK_LEFT_TITLE: 'Drehen Sie Ihren Kopf leicht nach links',
    LIVENESS_ACTION_LOOK_LEFT_TEXT:
        'Behalten Sie Ihre Augen immer auf dem Bildschirm',
    LIVENESS_ACTION_LOOK_RIGHT_TITLE:
        'Drehen Sie Ihren Kopf leicht nach rechts',
    LIVENESS_ACTION_LOOK_RIGHT_TEXT:
        'Behalten Sie Ihre Augen immer auf dem Bildschirm',
    LIVENESS_ACTION_LOOK_UP_TITLE: 'Drehen Sie Ihren Kopf leicht nach oben',
    LIVENESS_ACTION_LOOK_UP_TEXT:
        'Behalten Sie Ihre Augen immer auf dem Bildschirm',
    LIVENESS_ACTION_LOOK_DOWN_TITLE: 'Drehen Sie Ihren Kopf leicht nach unten',
    LIVENESS_ACTION_LOOK_DOWN_TEXT:
        'Behalten Sie Ihre Augen immer auf dem Bildschirm',
    LIVENESS_ACTION_SMILE_TITLE: 'Lächeln',
    LIVENESS_ACTION_SMILE_TEXT:
        'Behalten Sie Ihre Augen immer auf dem Bildschirm',
    LIVENESS_ACTION_FROWN_TITLE: 'Stirnrunzeln',
    LIVENESS_ACTION_FROWN_TEXT: 'Behalten Sie den Bildschirm immer im Auge.',
    PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE: 'Oh oh ... Sie sind zu nah.',
    PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE:
        'Oh oh ... Sie sind zu nah.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE:
        'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED:
        'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE:
        'Wir können im Bild kein Gesicht erkennen. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE:
        'Oh oh ... Sie sind zu weit weg.',
    PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE:
        'Oh oh ... Etwas ist schiefgelaufen.',
    ASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE:
        'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES:
        'Wir können im Bild kein Gesicht erkennen. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE:
        'Oh oh ... Wir können kein Gesicht erkennen.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE: 'Oh oh ... Etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN:
        'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE:
        'Oh oh ... Etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_INTERNAL:
        'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE:
        'Oh oh ... Etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD:
        'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_None_TITLE: 'Oh oh ... Etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_None:
        'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE:
        'Oh oh ... Etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_FailedExpressions:
        'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE:
        'Oh oh ... Etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE:
        'Oh oh ... etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR:
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE:
        'Oh oh ... etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR:
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE:
        'Oh oh ... etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE:
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE:
        'Oh oh ... etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL:
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE:
        'Oh oh ... etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE:
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE:
        'Oh oh ... etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG:
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE:
        'Oh oh ... etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD:
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE:
        'Oh oh ... etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT:
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE:
        'Oh oh ... etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT:
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE:
        'Oh oh ... etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS:
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE:
        'Oh oh ... etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE:
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE: 'Oh oh ... etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_NULLPTR:
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE:
        'Oh oh ... etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR:
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE:
        'Oh oh ... etwas ist schiefgelaufen.',
    PASSIVE_LIVENESS_ERROR_INVALID_META:
        'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    INITIALIZING_TITLE: 'Initialisierung',
    INITIALIZING_DESCRIPTION: 'Hardwarefähigkeiten überprüfen, bitte warten...',
    JOURNEY_STATE_STARTED: 'Begonnen',
    JOURNEY_STATE_INPROGRESS: 'In Bearbeitung',
    JOURNEY_STATE_ENDED: 'Beendet',
    INFO_JOURNEY_STATE: 'Zustand',
    INFO_JOURNEY_ACTION: 'Aktion',
    INFO_JOURNEY_ACTION_ATTEMPT: 'Aktionsversuch',
    INFO_JOURNEY_ID: 'Reise-ID',
    INFO_JOURNEY_RESULT: 'Ergebnis',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE: 'Ergebnismeldung',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE:
        'Die ID, die Sie uns gegeben haben, war veraltet – versuchen Sie etwas anderes',
    INFO_JOURNEY_REFERENCE: 'Referenz',
    FLOW_STATE_NONE: 'Keiner',
    'FLOW_STATE_IDENTITY:FRONT': 'Vorderseite',
    'FLOW_STATE_IDENTITY:BACK': 'Rückseite',
    FLOW_STATE_ADDRESS: 'Adresse',
    FLOW_STATE_SELFIE: 'Selbstporträt',
    FLOW_STATE_LIVENESS: 'Lebendigkeit',
    FLOW_STATE_COVID: 'Covid',
    PROVIDER_TITLE_CAMERA: 'Kamera',
    PROVIDER_TITLE_CROPPER: 'Ausschneider',
    PROVIDER_TITLE_FILESYSTEM_ID:
        'Laden Sie ein Foto Ihres Ausweisdokuments hoch',
    PROVIDER_TITLE_FILESYSTEM_FACEMATCH: 'Laden Sie ein Foto von sich hoch',
    PROVIDER_TITLE_FILESYSTEM_ADDRESS:
        'Laden Sie ein Foto Ihres Adressnachweises hoch',
    PROVIDER_TITLE_FILESYSTEM_COVID:
        'Laden Sie ein Foto Ihres Covid-Dokuments hoch',
    PROVIDER_TITLE_GATEWAY: 'Torweg',
    PROVIDER_TITLE_LIVENESS: 'Lebendigkeit',
    PROVIDER_TITLE_LOGIN: 'Anmeldung',
    PROVIDER_TITLE_RESULTS: 'Ergebnisse',
    PROVIDER_TITLE_SCANNER: 'Scannen Sie Ihr Ausweisdokument',
    PROVIDER_TITLE_VIEW_ID:
        'Überprüfen Sie die Vorschau Ihres Ausweisdokuments',
    PROVIDER_TITLE_VIEW_FACEMATCH: 'Überprüfen Sie die Vorschau Ihres Selfies',
    PROVIDER_TITLE_VIEW_ADDRESS:
        'Überprüfen Sie die Vorschau Ihres Adressnachweises',
    ROVIDER_TITLE_VIEW_COVID: 'Überprüfen Sie die Vorschau Ihres Covid',
    PROVIDER_SUBTITLE_FILESYSTEM_ID:
        'Bitte laden Sie ein Foto Ihres Ausweisdokuments hoch, das klar, scharf, nicht verdeckt und direkt von vorne zu sehen ist.',
    PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH:
        'Bitte laden Sie ein Foto von sich hoch, das klar, scharf, nicht verdeckt und direkt von vorne zu sehen ist.',
    PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS:
        'Bitte laden Sie ein Foto Ihres Dokuments hoch, das klar, scharf, nicht verdeckt und direkt von vorne zu sehen ist.',
    PROVIDER_SUBTITLE_FILESYSTEM_COVID:
        'Bitte laden Sie ein Foto Ihres Dokuments hoch, das klar, scharf, nicht verdeckt und direkt von vorne zu sehen ist.',
    PROVIDER_SUBTITLE_SCANNER_ID:
        'Legen Sie die Fotoseite Ihres Ausweisdokuments mit der Vorderseite nach unten auf den Scanner.',
    PROVIDER_SUBTITLE_VIEW_ID:
        'Bitte überprüfen Sie, ob die Vorschau Ihres Dokuments klar, scharf, nicht verdeckt und direkt von vorne zu sehen ist.',
    PROVIDER_SUBTITLE_VIEW_FACEMATCH:
        'Bitte überprüfen Sie, ob die Vorschau Ihres Selfies klar, scharf, nicht verdeckt und direkt von vorne zu sehen ist.',
    PROVIDER_SUBTITLE_VIEW_ADDRESS:
        'Bitte überprüfen Sie, ob die Vorschau Ihres Dokuments klar, scharf, nicht verdeckt und direkt von vorne zu sehen ist.',
    PROVIDER_SUBTITLE_VIEW_COVID:
        'Bitte überprüfen Sie, ob die Vorschau Ihres Dokuments klar, scharf, nicht verdeckt und direkt von vorne zu sehen ist.',
    PROVIDER_TITLE_SMART_CAPTURE: 'Intelligente Erfassung',
    PROVIDER_TITLE_JOURNEY_SELECT: 'Wählen Sie die Reise',
    PROVIDER_TITLE_TERMS_AND_CONDITIONS: 'Allgemeine Geschäftsbedingungen',
    PROVIDER_TITLE_USER_INPUT: 'Bitte füllen Sie das folgende Formular aus',
    FILESYSTEM_SUPPORTED_TYPES_FIRST: 'Akzeptierte Formate:',
    FILESYSTEM_SUPPORTED_TYPES_LIST: 'JPG, PNG',
    FILESYSTEM_SUPPORTED_TYPES_START_SELFIE: 'Akzeptierte Formate: JPG, PNG',
    FILESYSTEM_MAX_FILE_SIZE:
        'Dateigröße: Wir akzeptieren alle Dateien, die kleiner als ',
    FILESYSTEM_MAX_FILE_SIZE_NUMBER: '7,5 MB sind',
    FILESYSTEM_CHECK_FILE_TOO_BIG:
        'Ihre Datei ist zu groß. Bitte laden Sie eine Datei hoch, die kleiner als 7,5 MB ist.',
    FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT:
        'Ihre Datei hat das falsche Format. Bitte laden Sie eines der akzeptierten Formate hoch.',
    FILESYSTEM_IDENTITY_DOCUMENT: 'Ausweis',
    FILESYSTEM_FACEMATCH: 'Gesichtsübereinstimmung',
    FILESYSTEM_ADDRESS: 'Adressnachweis',
    FILESYSTEM_COVID: 'Covid',
    FILESYSTEM_DRAG_DROP: 'Ziehen und ablegen',
    FILESYSTEM_OR: 'oder',
    FILESYSTEM_CHOOSE: 'Datei auswählen',
    FILESYSTEM_UPLOADING: 'Hochladen...',
    TRIPLESCAN_GUIDANCE_TRYAGAIN: 'Erneut versuchen',
    FAILURE_REASON_REFER:
        'Ihr Ausweisdokument hat die Validierung nicht bestanden.',
    FAILURE_REASON_EXPIRED: 'Ihr Ausweisdokument ist abgelaufen.',
    FAILURE_REASON_NOT_ACCEPTED:
        'Ihr Ausweisdokument ist kein akzeptierter Dokumenttyp.',
    FAILURE_REASON_NOT_SUPPORTED:
        'Ihr Ausweisdokument konnte nicht klassifiziert werden oder wird nicht unterstützt.',
    PLEASE_TRY_AGAIN_REFER: 'Bitte versuchen Sie es erneut.',
    PLEASE_TRY_AGAIN_EXPIRED:
        'Bitte versuchen Sie es erneut mit einem gültigen Dokument.',
    PLEASE_TRY_AGAIN_NOT_ACCEPTED:
        'Bitte versuchen Sie es erneut mit einem anderen Dokument.',
    PLEASE_TRY_AGAIN_NOT_SUPPORTED: 'Bitte versuchen Sie es erneut.',
    BLUR_CHECK_REASON: 'Unschärfe – das Dokument ist unklar;',
    GLARE_CHECK_REASON:
        'Blendung – das Dokument ist aufgrund einer hellen Lichtquelle unlesbar;',
    RESOLUTION_CHECK_REASON:
        'Niedrige Auflösung – das Dokument füllt den Rahmen nicht richtig aus;',
    EDGES_CHECK_REASON:
        'Fehlende Kanten – das Dokument ist nicht richtig im Rahmen positioniert;',
    VALIDATION_FAILED: 'Validierung fehlgeschlagen',
    VALIDATION_FAILED_REASON_DOC_UNKNOWN: '– Dokument unbekannt.',
    VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED: '– Dokument nicht akzeptiert.',
    VALIDATION_FAILED_REASON_DOC_EXPIRED: '– Dokument abgelaufen.',
    PREVIEW_INFO_TITLE_ID: 'Beispiele für gute und schlechte Fotos',
    PREVIEW_INFO_GOOD: 'Gut',
    PREVIEW_INFO_BAD: 'Schlecht',
    PREVIEW_INFO_GOOD_EXAMPLE_ID:
        'Das Foto ist klar, scharf und direkt von vorne zu sehen.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID: 'Das Foto muss alle vier Ecken zeigen.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ID: 'Das Dokument darf nicht verdeckt sein.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID: 'Das Foto darf nicht verschwommen sein.',
    PREVIEW_INFO_TITLE_FACEMATCH:
        'Tipps für ein qualitativ hochwertiges Selfie',
    PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH:
        'Das Selfie ist klar, scharf und direkt von vorne.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH:
        'Das Selfie muss das ganze Gesicht zeigen.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH:
        'Das Gesicht darf nicht verdeckt sein.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH:
        'Das Selfie darf nicht unscharf sein.',
    PREVIEW_INFO_TITLE_ADDRESS: 'Tipps für ein qualitativ hochwertiges Foto',
    PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS:
        'Das Foto ist klar, scharf und direkt von vorne.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS:
        'Das Foto muss alle vier Ecken zeigen.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS:
        'Das Dokument darf nicht verdeckt sein.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS: 'Das Foto darf nicht unscharf sein.',
    PREVIEW_INFO_TITLE_COVID: 'Tipps für ein qualitativ hochwertiges Foto',
    PREVIEW_INFO_GOOD_EXAMPLE_COVID:
        'Das Foto ist klar, scharf und direkt von vorne zu sehen.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID:
        'Das Foto muss alle vier Ecken zeigen.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID:
        'Das Dokument darf nicht verdeckt sein.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID:
        'Das Foto darf nicht verschwommen sein.',
    ATTEMPTS_REMAINING: 'Anzahl verbleibender Versuche:',
    CAMERA_CAPTURE: 'Kamera einschalten',
    CAMERA_CAPTURE_START_BUTTON: 'Automatische Aufnahme starten',
    CAMERA_CAPTURE_CAPTION:
        'Klicken Sie auf „Automatische Aufnahme starten“, um zu beginnen',
    CAMERA_PREVIEW_START:
        'Schalten Sie Ihre Kamera ein, um die automatische Aufnahme zu starten',
    CAMERA_CONDITION_BLUR: 'Unschärfe erkannt',
    CAMERA_CONDITION_CAPTURING: 'Aufnahme wird ausgeführt',
    CAMERA_CONDITION_UPLOADING: 'Hochladen...Bitte warten',
    CAMERA_CONDITION_ALIGNMENT: 'Dokument nicht im Rahmen',
    CAMERA_CONDITION_GLARE: 'Blendung erkannt',
    VERIFYING_TITLE: 'Überprüfen ...',
    PREPARING_PREVIEW_TITLE: 'Vorschau wird vorbereitet ...',
    CAMERA_CONDITION_LOW_RESOLUTION: 'Dokument zu weit weg',
    CAMERA_LOADING: 'Kamera wird geöffnet ...',
    CAMERA_SMARTCAPTURE_ON: 'AUTOMATISCHE AUFNAHME – EIN',
    CAMERA_SMARTCAPTURE_OFF: 'AUTOMATISCHE AUFNAHME – AUS',
    CAMERA_CAPTURE_FRONT:
        'Positionieren Sie die Seite mit dem Foto Ihres Ausweisdokuments im Rahmen unten.',
    CAMERA_MANUAL_CAPTURE_FRONT:
        'Positionieren Sie Ihr Ausweisdokument innerhalb des Rahmens und klicken Sie auf die Schaltfläche unten',
    CAMERA_CAPTURE_BACK:
        'Positionieren Sie die RÜCKSEITE Ihres Ausweisdokuments innerhalb des Rahmens',
    CAMERA_CAPTURE_SELFIE_CAPTION:
        'Positionieren Sie Ihr Gesicht innerhalb des Ovals, schauen Sie direkt in die Kamera und klicken Sie auf die Schaltfläche unten, um ein Selfie aufzunehmen.',
    AMERA_CAPTURE_ADDRESS_CAPTION:
        'Positionieren Sie Ihren Adressnachweis innerhalb des Rahmens und klicken Sie auf die Schaltfläche unten, um ein Foto aufzunehmen.',
    CAMERA_CAPTURE_COVID_CAPTION:
        'Positionieren Sie Ihr Covid-Dokument innerhalb des Rahmens und klicken Sie auf die Schaltfläche unten, um ein Foto aufzunehmen.',
    CAMERA_PREVENT_GLARE_HINT:
        'Halten Sie das Dokument von direkten Lichtquellen fern.',
    CAMERA_PREVENT_BLUR_HINT: 'Halten Sie das Dokument oder Gerät ruhig.',
    CAMERA_PREVENT_LOW_RES_HINT:
        'Passen Sie das Dokument vollständig in den Rahmen ein.',
    CROPPER_RETRY: 'Erneut versuchen',
    CROPPER_UPLOAD: 'Hochladen',
    CROPPER_UPLOADING: 'Wird hochgeladen...',
    FILESYSTEM_SELECT: 'Bild auswählen',
    FILESYSTEM_DROP_IMAGE: 'oder ablegen',
    GATEWAY_CAMERA: 'Kamera aktiviert',
    GATEWAY_CANCEL: 'Reise abbrechen',
    LIVENESS_START: 'Liveness starten',
    PASSIVE_LIVENESS_START: 'Bild aufnehmen',
    LOGIN_USERNAME: 'Benutzername',
    LOGIN_PASSWORD: 'Passwort',
    LOGIN_SUBMIT: 'Einreichen',
    RESULTS_DOCUMENTS: 'Dokumente',
    RESULTS_DOCUMENTS_NONE: 'Keine gefunden',
    RESULTS_DOCUMENT_TYPE: 'Dokumenttyp',
    RESULTS_DOCUMENT_RESULT: 'Dokumentergebnis',
    RESULTS_EXTRACTED_FIELDS_NONE: 'Ergebnisdetails',
    RESULTS_DETAILS_NONE: 'Keine gefunden',
    RESULTS_NEW_JOURNEY: 'Starte eine neue Reise.',
    RESULTS_NO_INFORMATION:
        'Für diese Reise sind keine Informationen verfügbar',
    RESULTS_LOGOUT: 'Abmelden',
    RESULTS_HIGH_LEVEL_Aborted: 'Abgebrochen',
    RESULTS_HIGH_LEVEL_TCCDISAGREE: 'Abgebrochene AGB',
    RESULTS_HIGH_LEVEL_Expired: 'Abgelaufen',
    RESULTS_HIGH_LEVEL_NotAccepted: 'Nicht akzeptiert.',
    RESULTS_HIGH_LEVEL_NotSupported: 'Nicht unterstützt.',
    RESULTS_HIGH_LEVEL_Notsupported: 'Nicht unterstützt.',
    RESULTS_HIGH_LEVEL_Passed: 'Bestanden',
    RESULTS_HIGH_LEVEL_Refer: 'Verweis',
    RESULTS_HIGH_LEVEL_Undefined: 'Undefiniert',
    RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVELIVENESSRESULT:
        'Kumulatives Lebendigkeitsergebnis',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTFRONTSIDETYPECHECK:
        'Dokument Vorderseite Typenprüfung',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDECHECK:
        'Rückseite des Dokuments überprüfen',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBLOCKINGPOLICY:
        'Dokumenten-Sperrrichtlinie',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTEXPIRY: 'Dokumentablauf',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTSUPPORT: 'Dokumentenunterstützung',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTVALIDATION: 'Dokumentenvalidierung',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTPROOFPOLICY: 'Dokumentnachweisrichtlinie',
    RESULTS_HIGH_LEVEL_DETAIL_FACEMATCHVALIDATION: 'Facematch Validierung',
    RESULTS_HIGH_LEVEL_DETAIL_UNDERAGERULE: 'Minderjährigenregel',
    ESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESS_NEEDED: 'Erfolgreiche',
    RESULTS_HIGH_LEVEL_DETAIL_COVID_PASS_CROSSCHECK:
        'Überprüfung der Kompatibilität des Covid-Passes',
    RESULTS_HIGH_LEVEL_DETAIL_DATA_CHECK: 'Datenprüfungen',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED: 'Gescheitert',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED: 'Nicht benötigt.',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED: 'Bestanden',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED: 'Überspringen',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED: 'Unbestimmt',
    ADDITIONAL_CHECKS_DETAILS: 'Zusätzliche Prüfungen',
    ADDITIONAL_CHECKS_DETAILS_NONE: 'Keine gefunden',
    ADDITIONAL_CHECKS_DETAIL_DATACHECKS: 'Datenprüfungen',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK: 'Rückblickprüfungen',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA: 'N/A',
    GBG_SCORES: 'GBG-Scores',
    GBG_TRUST_SCORE: 'GBG-Vertrauens-Score',
    GBG_SCORE: 'GBG-Score',
    PREVIEW_TITLE: 'Ist das Foto Ihres Dokuments klar?',
    VIEW_RETRY: 'NOCH EINMAL AUFNEHMEN',
    VIEW_RETRY_DESKTOP: 'Foto ändern',
    VIEW_CROP: 'Ernte',
    VIEW_CROPPING: 'Zuschneiden...',
    VIEW_UPLOAD: 'Hochladen',
    VIEW_UPLOAD_PREVIEW: 'JA, FORTFAHREN',
    VIEW_UPLOADING: 'Hochladen...',
    SMART_CAPTURE_INITIALIZING: 'Beginn',
    SMART_CAPTURE_START: 'Initialisierung von Smart Capture, Bitte warten...',
    SCANNER_DESC_AVAILABLE:
        'Der Scanner ist verfügbar. Legen Sie Ihr Dokument in den Scanner.',
    SCANNER_DESC_PROCESSING: 'Das Bild wird vom Server verarbeitet.',
    SCANNER_DESC_SCANNING: 'Das Bild wird vom Gerät gescannt.',
    SCANNER_DESC_DISCONNECTED: 'Der Scanner ist vom Netzwerk getrennt.',
    SCANNER_DESC_NOT_CONNECTED: 'Der Scanner ist nicht verbunden.',
    SCANNER_DESC_OFFLINE: 'Der Scanner ist offline.',
    SCANNER_DESC_BUSY:
        'Der Scanner wird von einem anderen Benutzer in Ihrem lokalen Netzwerk verwendet.',
    SCANNER_DESC_WAITING:
        'Warten darauf, dass die Verbindung hergestellt wird.',
    SCANNER_DESC_LOADING: 'Bitte warten...',
    SCANNER_TITLE_SCANNING: 'Scannen...',
    SCANNER_TITLE_DISCONNECTED: 'GETRENNT',
    SCANNER_TITLE_NOT_CONNECTED: 'NICHT VERBUNDEN',
    SCANNER_TITLE_OFFLINE: 'Scanner offline',
    SCANNER_TITLE_BUSY: 'Scanner ausgelastet',
    SCANNER_TITLE_WAITING: 'WARTEN',
    SCANNER_ACTION_REGISTER: 'Registrieren',
    SCANNER_ACTION_RELEASE: 'Veröffentlichung',
    CANCEL_JOURNEY: 'Abbrechen',
    MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE: 'Stattdessen ein Foto hochladen',
    MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE: 'Stattdessen ein Foto aufnehmen',
    JOURNEY_SELECT_CONTINUE: 'Weiter',
    HELP_MODAL_AUTOCAPTURE_TITLE:
        'So nehmen Sie ein Foto Ihres Ausweisdokuments auf',
    HELP_MODAL_AUTOCAPTURE_SUBTITLE:
        'Wenn die automatische Erfassung aktiviert ist, nimmt der Erfassungsbildschirm automatisch ein Foto Ihres Dokuments auf, sobald er erkannt hat, dass die Qualität gut genug ist.',
    HELP_MODAL_AUTOCAPTURE_TIPS:
        'Tipps für die Aufnahme eines Fotos in guter Qualität',
    HELP_MODAL_AUTOCAPTURE_GLARE_TITLE: 'Blendeffekte vermeiden',
    HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE:
        'Halten Sie das Dokument von direkten Lichtquellen fern.',
    HELP_MODAL_AUTOCAPTURE_FAR_TITLE: 'Dokument zu weit entfernt',
    AUTOCAPTURE_FAR_SUBTITLE:
        'Platzieren Sie das Dokument vollständig innerhalb des Rahmens.',
    AUTOCAPTURE_BLUR_TITLE: 'Unschärfe vermeiden',
    HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE:
        'Halten Sie das Dokument oder Gerät ruhig.',
    HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE:
        'Haben Sie immer noch Probleme? Machen Sie ein Foto mit manueller Aufnahme',
    HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE: 'Manuelle Aufnahme',
    HELP_MODAL_SELFIE_TITLE: 'So machen Sie ein Selfie',
    HELP_MODAL_SELFIE_SUBTITLE:
        'Schauen Sie direkt in die Kamera und klicken Sie auf die Schaltfläche für die manuelle Aufnahme.',
    HELP_MODAL_POA_TITLE: 'So machen Sie ein Foto von Ihrem Adressnachweis',
    HELP_MODAL_POA_SUBTITLE:
        'Positionieren Sie Ihr Dokument innerhalb des Rahmens und klicken Sie auf die Schaltfläche für die Aufnahme, um ein Foto von Ihrem Dokument zu machen.',
    HELP_MODAL_POA_TIPS: 'Tipps für die Aufnahme eines Fotos in guter Qualität',
    HELP_MODAL_POA_GLARE_TITLE: 'Blendeffekte vermeiden',
    HELP_MODAL_POA_GLARE_SUBTITLE:
        'Halten Sie das Dokument von direkten Lichtquellen fern.',
    HELP_MODAL_POA_FAR_TITLE: 'Dokument zu weit entfernt',
    HELP_MODAL_POA_FAR_SUBTITLE:
        'Passen Sie das Dokument vollständig in den Rahmen ein.',
    HELP_MODAL_POA_BLUR_TITLE: 'Verwacklungen vermeiden',
    HELP_MODAL_POA_BLUR_SUBTITLE: 'Halten Sie das Dokument oder Gerät ruhig.',
    HELP_MODAL_POA_MANUAL_CAPTURE:
        'Haben Sie immer noch Probleme? Aktivieren Sie die manuelle Erfassung',
    HELP_MODAL_POA_TURN_MANUAL_CAPTURE: 'Manuelle Erfassung',
    HELP_MODAL_COVID_TITLE: 'So fotografieren Sie Ihr Covid-Dokument',
    HELP_MODAL_COVID_SUBTITLE:
        'Positionieren Sie Ihr Dokument innerhalb des Rahmens und klicken Sie auf die Schaltfläche „Erfassen“, um ein Foto Ihres Dokuments zu machen.',
    HELP_MODAL_COVID_TIPS: 'Tipps für ein Foto in guter Qualität',
    HELP_MODAL_COVID_GLARE_TITLE: 'Blendeffekte vermeiden',
    HELP_MODAL_COVID_GLARE_SUBTITLE:
        'Halten Sie das Dokument von direkten Lichtquellen fern.',
    HELP_MODAL_COVID_FAR_TITLE: 'Dokument zu weit entfernt',
    HELP_MODAL_COVID_FAR_SUBTITLE:
        'Passen Sie das Dokument vollständig in den Rahmen ein.',
    HELP_MODAL_COVID_BLUR_TITLE: 'Unschärfe vermeiden',
    HELP_MODAL_COVID_BLUR_SUBTITLE: 'Halten Sie das Dokument oder Gerät ruhig.',
    HELP_MODAL_COVID_MANUAL_CAPTURE:
        'Immer noch Probleme? Aktivieren Sie die manuelle Erfassung',
    HELP_MODAL_COVID_TURN_MANUAL_CAPTURE: 'Manuelle Erfassung',
    HELP_MODAL_NEED_HELP: 'Hilfe und Optionen',
    EXCEPTION: 'Eine unerwartete Ausnahme ist aufgetreten.',
    EXCEPTION_AUTHORIZATION: 'Nicht autorisiert',
    EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED:
        'Ihr Konto ist nicht für den Zugriff auf diese Ressource autorisiert.',
    EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID:
        'Die Kombination aus Benutzername und Passwort ist ungültig.',
    EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED:
        'Sie müssen die Authentifizierung aktivieren, um diese Funktion nutzen zu können.',
    EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED:
        'Sie sind für diesen Vorgang nicht autorisiert.',
    EXCEPTION_BAD_REQUEST: 'Falsche Anfrage mit Statuscode 400',
    EXCEPTION_BAD_REQUEST_INVALID_IMAGE: 'Kein gültiges Bild',
    EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE:
        'Die Reise wartet auf eine Antwort',
    EXCEPTION_FLOW_STATE_JOURNEY_ENDED:
        'Anfragen können nicht gesendet werden. Die Reise ist beendet',
    EXCEPTION_FLOW_STATE_MISSING: 'Flussstatus nicht gefunden',
    EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION:
        'Rückruf muss eine gültige Funktion sein.',
    EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING:
        'Der Veranstaltungsname muss ein Zeichenfolgenwert sein.',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER:
        'Priorität muss eine Zahl sein.',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER:
        'Priorität muss eine positive Zahl sein.',
    EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR:
        'Container sollte entweder ein Element oder ein Selektor sein.',
    EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID: 'Wert ist ungültig.',
    EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED: 'Wert wurde beschädigt.',
    EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING:
        'Die Konfiguration sollte einen backendUrl-Parameter enthalten.',
    EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING:
        'Die gelieferten Parameter müssen Koordinaten enthalten.',
    EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING:
        'Die gelieferten Parameter müssen Bilder enthalten.',
    EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING:
        'Die bereitgestellten Parameter sollten das Passwort enthalten.',
    EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING:
        'Die bereitgestellten Parameter sollten den Benutzernamen enthalten.',
    EXCEPTION_MISSING_REQUIRED_FIELD_MISSING:
        'Bitte füllen Sie alle erforderlichen Felder aus',
    EXCEPTION_POSTCODE_FORMAT_ERROR:
        'Das Format der Postleitzahl ist ungültig minLength:5 / maxLength:8',
    EXCEPTION_HOUSENUMBER_FORMAT_ERROR:
        'Das Format von Hausname/Hausnummer ist ungültig minLength:1 / maxLength:20',
    EXCEPTION_STREETNAME_FORMAT_ERROR:
        'Der Straßenname ist ungültig minLength:1 / maxLength:30',
    EXCEPTION_TOWN_FORMAT_ERROR:
        'Das Format der Stadt ist ungültig minLength:1 / maxLength:20',
    EXCEPTION_JOURNEY_DEFINITIONS_MISSING:
        'Für diesen Kanal sind keine Reisedefinitionen verfügbar',
    EXCEPTION_NETWORK:
        'Es ist eine Netzwerkausnahme aufgetreten. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut',
    EXCEPTION_PLATFORM_BROWSER_ONLY:
        'Diese Funktion kann nur im Browser verwendet werden',
    EXCEPTION_PLATFORM_UNSUPPORTED:
        'Ihre Umgebung unterstützt diese Funktion nicht',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED:
        'Es wurden keine Kameraberechtigungen erteilt. Bitte überprüfen Sie Ihre Browsereinstellungen',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE: '',
    EXCEPTION_PLATFORM_CAMERA_NOT_READABLE:
        'Auf die Kamera konnte nicht zugegriffen werden. Bitte schließen Sie alle anderen Anwendungen und versuchen Sie es erneut',
    EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE:
        'Auf Ihrem Gerät wurden keine geeigneten Kameras gefunden',
    EXCEPTION_SERVER: 'Anfrage mit Statuscode 500 fehlgeschlagen',
    EXCEPTION_SERVER_UNREACHABLE:
        'Anfrage fehlgeschlagen, Server nicht erreichbar',
    EXCEPTION_SERVER_DATA_NOT_PERSISTED:
        'Während des Vorgangs ist ein Fehler aufgetreten. Ihre Daten werden möglicherweise nicht beibehalten',
    EXCEPTION_SERVER_RESULT_NOT_PASSING: 'Aktuelles Ergebnis nicht bestanden',
    EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE:
        'Canvas-Kontext nicht verfügbar',
    EXCEPTION_TEMPLATE_CONTAINER_MISSING: 'Container ist nicht vorhanden',
    EXCEPTION_TEMPLATE_ELEMENTS_MISSING: 'Erforderliche Elemente fehlen',
    EXCEPTION_TEMPLATE_MISSING: 'Vorlage nicht gefunden',
    EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING: 'Quellelement nicht auffindbar',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE:
        'Eingabeprovider können nicht abgerufen werden',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED:
        'Keine Eingabeprovider angegeben',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE:
        'Eingabeprovider ist nicht verfügbar',
    'SUPPORTED_DOCUMENT_Account Statement': 'Kontoauszug',
    'SUPPORTED_DOCUMENT_Agreement (Tenancy)': 'Vereinbarung (Miete)',
    'SUPPORTED_DOCUMENT_Bank Document': 'Bankdokument',
    'SUPPORTED_DOCUMENT_Bank Letter': 'Bankbrief',
    'SUPPORTED_DOCUMENT_Bank Statement': 'Kontoauszug',
    'SUPPORTED_DOCUMENT_Benefit Letter': 'Leistungsbescheid',
    'SUPPORTED_DOCUMENT_Certificate (Birth, Marriage, Civil partnership)':
        'Urkunde (Geburt, Heirat, Lebenspartnerschaft)',
    'SUPPORTED_DOCUMENT_Council Document': 'Ratsdokument',
    'SUPPORTED_DOCUMENT_Council Letter': 'Ratsbrief',
    'SUPPORTED_DOCUMENT_Council Tax': 'Grundsteuer',
    'SUPPORTED_DOCUMENT_Driving License': 'Führerschein',
    'SUPPORTED_DOCUMENT_Driving Licence': 'Führerschein',
    'SUPPORTED_DOCUMENT_DWP Document': 'DWP-Dokument',
    'SUPPORTED_DOCUMENT_HMRC Document': 'HMRC-Dokument',
    'SUPPORTED_DOCUMENT_Information Sheet': 'Informationsblatt',
    'SUPPORTED_DOCUMENT_Insurance Document': 'Versicherungsdokument',
    'SUPPORTED_DOCUMENT_Insurance Letter': 'Versicherungsschreiben',
    SUPPORTED_DOCUMENT_Invoice: 'Rechnung',
    'SUPPORTED_DOCUMENT_NIC Letter': 'NIC-Brief',
    'SUPPORTED_DOCUMENT_NINO Letter': 'NINO Brief',
    'SUPPORTED_DOCUMENT_Official Document': 'Offizielles Dokument',
    'SUPPORTED_DOCUMENT_Official Letter': 'Offizielles Schreiben',
    'SUPPORTED_DOCUMENT_Repayment Letter (related to Tax or Social support)':
        'Rückzahlungsschreiben (bezogen auf Steuern oder Sozialleistungen)',
    'SUPPORTED_DOCUMENT_Tax Letter': 'Steuerbrief',
    'SUPPORTED_DOCUMENT_Tax Statement': 'Steuererklärung',
    'SUPPORTED_DOCUMENT_Tel Bill': 'Telefonrechnung',
    'SUPPORTED_DOCUMENT_Tel Letter': 'Tel Brief',
    'SUPPORTED_DOCUMENT_Telecommunication Document':
        'Telekommunikationsdokument',
    'SUPPORTED_DOCUMENT_TV Licence': 'Rundfunkbeitrag',
    'SUPPORTED_DOCUMENT_University Letter': 'Universitätsbrief',
    'SUPPORTED_DOCUMENT_Utility Bill': 'Nebenkostenabrechnung',
    'SUPPORTED_DOCUMENT_Utility Document': 'Dienstdokument',
    'SUPPORTED_DOCUMENT_Utility Letter': 'Nutzbrief',
    'SUPPORTED_DOCUMENT_Water Bil': 'Wasserrechnung',
    'SUPPORTED_DOCUMENT_Water Document': 'Wasser Dokument',
    'SUPPORTED_DOCUMENT_Agents License': 'Agentenlizenz',
    'SUPPORTED_DOCUMENT_Electoral Card': 'Wahlkarte',
    'SUPPORTED_DOCUMENT_Foreigner Identification Card': 'Ausländerausweis',
    'SUPPORTED_DOCUMENT_Health Card': 'Gesundheitskarte',
    'SUPPORTED_DOCUMENT_Job License': 'Berufslizenz',
    'SUPPORTED_DOCUMENT_Membership Identification Card': 'Mitgliedsausweis',
    'SUPPORTED_DOCUMENT_Military Identification Card': 'Militärischer Ausweis',
    'SUPPORTED_DOCUMENT_National Identification Card': 'Personalausweis',
    SUPPORTED_DOCUMENT_Passport: 'Reisepass',
    'SUPPORTED_DOCUMENT_Travel Permit': 'Reiseerlaubnis',
    SUPPORTED_DOCUMENT_Visa: 'Visum',
    'SUPPORTED_DOCUMENT_Weapons Licence': 'Waffenbesitzkarte',
    'SUPPORTED_DOCUMENT_Selfie Photo': 'Selfie-Foto',
    SUPPORTED_DOCUMENT_Unknown: 'Unbekannt',
    SUPPORTED_DOCUMENT_COVIDPAS: 'Covid-Pass',
    EXTRACTED_FIELDS_AddressFull: 'Adresse Vollständig',
    EXTRACTED_FIELDS_AddressCity: 'Adresse Stadt',
    EXTRACTED_FIELDS_AddressPostCode: 'Adresse Postleitzahl',
    EXTRACTED_FIELDS_LastNameFirstPart: 'Nachname Erster Teil',
    EXTRACTED_FIELDS_Sex: 'Geschlecht',
    EXTRACTED_FIELDS_BirthPlace: 'Geburtsort',
    EXTRACTED_FIELDS_IssueNumber: 'Ausgabenummer',
    EXTRACTED_FIELDS_DocumentNumberCheckDigit: 'Dokumentennummer Prüfziffer',
    EXTRACTED_FIELDS_BirthDate: 'Geburtsdatum',
    EXTRACTED_FIELDS_DocumentNumber: 'Dokumentennummer',
    EXTRACTED_FIELDS_FirstName: 'Vorname',
    EXTRACTED_FIELDS_ArbitraryDigit: 'Beliebige Ziffer',
    EXTRACTED_FIELDS_FirstNameInitial: 'Vorname Anfangsbuchstabe',
    EXTRACTED_FIELDS_ExpiryDate: 'Ablaufdatum',
    EXTRACTED_FIELDS_IssueDate: 'Ausgabedatum',
    EXTRACTED_FIELDS_LastName: 'Nachname',
    EXTRACTED_FIELDS_LicenseCategory: 'Lizenzkategorie',
    EXTRACTED_FIELDS_DocumentCategory: 'Dokumentenkategorie',
    EXTRACTED_FIELDS_DocumentType: 'Dokumententyp',
    EXTRACTED_FIELDS_NationalityCode: 'Nationalitätscode',
    EXTRACTED_FIELDS_MiddleName: 'Zweiter Vorname',
    EXTRACTED_FIELDS_FirstIssuanceDate: 'Erstausgabedatum',
    EXTRACTED_FIELDS_SecondLastName: 'Zweiter Nachname',
    EXTRACTED_FIELDS_FullName: 'Vollständiger Name',
    EXTRACTED_FIELDS_PersonalNumber: 'Personalnummer',
    EXTRACTED_FIELDS_NationalityName: 'Nationalität',
    EXTRACTED_FIELDS_BarcodeItems: 'BarcodeS',
    EXTRACTED_FIELDS_BirthPlaceCity: 'Geburtsstadt',
    EXTRACTED_FIELDS_BirthPlaceState: 'Geburtsort',
    EXTRACTED_FIELDS_BirthPlaceCountry: 'Geburtsland',
    EXTRACTED_FIELDS_MRZFull: 'Vollständige MRZ',
    EXTRACTED_FIELDS_MRZLine1: 'MRZ Zeile 1',
    EXTRACTED_FIELDS_MRZLine2: 'MRZ Zeile 2',
    EXTRACTED_FIELDS_MRZLine3: 'MRZ Zeile 3',
    EXTRACTED_FIELDS_ObservationPage: 'Beobachtungsseite',
    EXTRACTED_FIELDS_IssuingAuthority: 'Ausstellungsbehörde',
    EXTRACTED_FIELDS_IssuingLocation: 'Ausgabestelle',
    EXTRACTED_FIELDS_MaritalStatus: 'Familienstand',
    EXTRACTED_FIELDS_Occupation: 'Besetzung',
    EXTRACTED_FIELDS_AlienNumber: 'Außerirdische Nummer',
    EXTRACTED_FIELDS_Employer: 'Arbeitgeber',
    EXTRACTED_FIELDS_AddressLine1: 'Adresszeile 1',
    EXTRACTED_FIELDS_AddressLine2: 'Adresszeile 2',
    EXTRACTED_FIELDS_AddressLine3: 'Adresszeile 3',
    EXTRACTED_FIELDS_AddressLine4: 'Adresszeile 4',
    EXTRACTED_FIELDS_AddressState: 'Zustand',
    EXTRACTED_FIELDS_AddressDistrict: 'Bezirk',
    EXTRACTED_FIELDS_AddressBuildingNumber: 'Gebäudenummer',
    EXTRACTED_FIELDS_AddressBuildingName: 'Gebäudename',
    EXTRACTED_FIELDS_AddressStreet: 'Straße',
    EXTRACTED_FIELDS_AddressCountry: 'Land',
    EXTRACTED_FIELDS_RefAddressFull: 'Referenzadresse',
    EXTRACTED_FIELDS_RefAddressLine1: 'Referenzadresse Zeile 1',
    EXTRACTED_FIELDS_RefAddressLine2: 'Referenzadresse Zeile 2',
    EXTRACTED_FIELDS_RefAddressLine3: 'Referenzadresse Zeile 3',
    EXTRACTED_FIELDS_RefAddressLine4: 'Referenzadresse Zeile 4',
    EXTRACTED_FIELDS_RefAddressCity: 'Referenz Adresse Stadt',
    EXTRACTED_FIELDS_RefAddressState: 'Referenzadresse Zustand',
    EXTRACTED_FIELDS_RefAddressDistrict: 'Referenzadresse Bezirk',
    EXTRACTED_FIELDS_RefAddressBuildingNumber: 'Referenzadresse Gebäudenummer',
    EXTRACTED_FIELDS_RefAddressBuildingName: 'Referenzadresse Gebäude Name',
    EXTRACTED_FIELDS_RefAddressSubBuildingName:
        'Referenzadresse Untergebäudename',
    EXTRACTED_FIELDS_RefAddressStreet: 'Referenzadresse Straße',
    EXTRACTED_FIELDS_RefAddressCountry: 'Referenzadresse Land',
    EXTRACTED_FIELDS_RefAddressPostCode: 'Referenzadresse Postleitzahl',
    EXTRACTED_FIELDS_HealthNumber: 'Gesundheitsnummer',
    EXTRACTED_FIELDS_Endorsements: 'Befürwortungen',
    EXTRACTED_FIELDS_Constraints: 'Einschränkungen',
    EXTRACTED_FIELDS_LicenseMarine: 'Lizenz Marine',
    EXTRACTED_FIELDS_Height: 'Höhe',
    EXTRACTED_FIELDS_Weight: 'Gewicht',
    EXTRACTED_FIELDS_HairColor: 'Haarfarbe',
    EXTRACTED_FIELDS_EyeColor: 'Augenfarbe',
    EXTRACTED_FIELDS_LensData: 'Sehkraft',
    EXTRACTED_FIELDS_SocialSecurityNumber: 'Sozialversicherungsnummer',
    EXTRACTED_FIELDS_NationalInsuranceNumber: 'Sozialversicherungsnummer',
    EXTRACTED_FIELDS_Race: 'Rennen',
    EXTRACTED_FIELDS_MotherName: 'Muttername',
    EXTRACTED_FIELDS_FatherName: 'Vaters Name',
    EXTRACTED_FIELDS_Parents: 'Eltern',
    EXTRACTED_FIELDS_Remarks: 'Bemerkungen',
    EXTRACTED_FIELDS_DistinguishingMarks: 'Kennzeichen',
    EXTRACTED_FIELDS_PeriodOfStay: 'Aufenthaltsdauer',
    EXTRACTED_FIELDS_TaxNumber: 'Steuernummer',
    EXTRACTED_FIELDS_Donor: 'Spender',
    EXTRACTED_FIELDS_RFIDG1: 'RFID Rohdatengruppe 1',
    EXTRACTED_FIELDS_RFIDG2: 'RFID Rohdatengruppe 2',
    EXTRACTED_FIELDS_RFIDG3: 'RFID Rohdatengruppe 3',
    EXTRACTED_FIELDS_RFIDG15: 'RFID Rohdatengruppe 4',
    EXTRACTED_FIELDS_RFIDSOD: 'RFID Rohdatengruppe 5',
    EXTRACTED_FIELDS_PortraitPhoto: 'Extrahiertes Porträtfoto',
    EXTRACTED_FIELDS_Title: 'Titel',
    EXTRACTED_FIELDS_IssueDate2: 'Zweites Ausgabedatum',
    EXTRACTED_FIELDS_ExpiryDate2: 'Zweites Verfallsdatum',
    EXTRACTED_FIELDS_LicenseCategory2: 'Zweite Lizenzkategorie',
    EXTRACTED_FIELDS_IssueDate3: 'Drittes Ausgabedatum',
    EXTRACTED_FIELDS_ExpiryDate3: 'Drittes Verfallsdatum',
    EXTRACTED_FIELDS_LicenseCategory3: 'Dritte Lizenzkategorie',
    EXTRACTED_FIELDS_IssueDate4: 'Vierte Ausgabedatum',
    EXTRACTED_FIELDS_ExpiryDate4: 'Vierte Verfallsdatum',
    EXTRACTED_FIELDS_LicenseCategory4: 'Vierte Lizenzkategorie',
    EXTRACTED_FIELDS_MRZCode1: 'MRZ-Code 1',
    EXTRACTED_FIELDS_MRZCode2: 'MRZ-Code 2',
    EXTRACTED_FIELDS_MRZStandardType: 'MRZ Standardtyp',
    EXTRACTED_FIELDS_AddressStreetSuffix: 'Straßenendung',
    EXTRACTED_FIELDS_AddressStreetType: 'Straßentyp',
    EXTRACTED_FIELDS_AddressUnitNumber: 'Adresseneinheit Nummer',
    EXTRACTED_FIELDS_LicenseNumber: 'Lizenznummer',
    EXTRACTED_FIELDS_AddressStateCode: 'Bundesland Code',
    EXTRACTED_FIELDS_AddressStreetTypeAbbreviation: 'Straßenkürzel',
    EXTRACTED_FIELDS_AddressUnitType: 'Adresseneinheitstyp',
    EXTRACTED_FIELDS_AddressDeliveryPointIdentifier:
        'Zustellpunkt-Identifikator',
    EXTRACTED_FIELDS_AgeCategory: 'Alterskategorie',
    EXTRACTED_FIELDS_ChildernCount: 'Anzahl der Kinder',
    EXTRACTED_FIELDS_EntryMode: 'Eingabemodus',
    EXTRACTED_FIELDS_VAFNumber: 'VAF-Nummer',
    EXTRACTED_FIELDS_AddressLine5: 'Adresszeile 5',
    EXTRACTED_FIELDS_RFIDPortraitPhoto: 'RFID Porträtfoto',
    EXTRACTED_FIELDS_RefAddressLine5: 'Referenzadresse Zeile 5',
    EXTRACTED_FIELDS_RefAddressStateCode: 'Referenzadresse Zustand',
    EXTRACTED_FIELDS_RefAddressStreetType: 'Referenzadresse Straßentyp',
    EXTRACTED_FIELDS_RefAddressStreetTypeAbbreviation:
        'Referenzadresse Straßentyp Abkürzung',
    EXTRACTED_FIELDS_RefAddressStreetSuffix: 'Referenzadresse Straßensuffix',
    EXTRACTED_FIELDS_RefAddressUnitNumber: 'Referenzadresse Einheit Nummer',
    EXTRACTED_FIELDS_RefAddressUnitType: 'Referenzadresse Einheitstyp',
    EXTRACTED_FIELDS_RefAddressPostcodeType:
        'Referenz Adresse Postleitzahl Typ',
    EXTRACTED_FIELDS_RefAddressDeliveryPointIdentifier:
        'Referenz-Adresslieferpunkt-Identifier',
    EXTRACTED_FIELDS_RefAddressPOBoxNumber: 'Referenzadresse Postfachnummer',
    EXTRACTED_FIELDS_RefAddressDependentLocality:
        'Referenzadresse Abhängige Ortschaft',
    EXTRACTED_FIELDS_RefAddressDoubleDependentLocality:
        'Referenzadresse Doppelte abhängige Ortschaft',
    EXTRACTED_FIELDS_RefAddressThoroughfare: 'Referenzadresse Straße',
    EXTRACTED_FIELDS_RefAddressThoroughfareDesc:
        'Referenzadresse Straßenbeschreibung',
    EXTRACTED_FIELDS_RefAddressDependentThoroughfare:
        'Referenzadresse abhängige Durchgangsstraße',
    EXTRACTED_FIELDS_RefAddressDependentThoroughfareDesc:
        'Referenzadresse abhängige Straßenbeschreibung',
    EXTRACTED_FIELDS_RefAddressSubBuildingNumber:
        'Referenzadresse Unter Gebäude Nummer',
    EXTRACTED_FIELDS_AddressSubBuildingNumber: 'Gebäude Nummer',
    EXTRACTED_FIELDS_AddressSubBuildingName: 'Gebäude Name',
    EXTRACTED_FIELDS_AddressPostCodeType: 'Postleitzahltyp',
    EXTRACTED_FIELDS_IssuingAuthorityType: 'Ausstellungsbehördenart',
    EXTRACTED_FIELDS_Signature: 'Unterschrift',
    EXTRACTED_FIELDS_Hologram: 'Hologramm',
    EXTRACTED_FIELDS_CardNumber: 'Kartennummer',
    EXTRACTED_FIELDS_MiddleNameInitial: 'Zweiter Vorname Anfangsbuchstabe',
    EXTRACTED_FIELDS_PermitNumber: 'Erlaubnisnummer',
    EXTRACTED_FIELDS_ReferenceNumber: 'Referenznummer',
    EXTRACTED_FIELDS_CustomerNumber: 'Kundennummer',
    EXTRACTED_FIELDS_BOSNumber: 'BOS-Nummer',
    EXTRACTED_FIELDS_StudentID: 'Matrikelnummer',
    EXTRACTED_FIELDS_MembershipNumber: 'Mitgliedsnummer',
    EXTRACTED_FIELDS_LicenseType: 'Lizenztyp',
    EXTRACTED_FIELDS_LicenseType2: 'Lizenztyp 2',
    EXTRACTED_FIELDS_LicenseType3: 'Lizenztyp 3',
    EXTRACTED_FIELDS_LicenseType4: 'Lizenztyp 4',
    EXTRACTED_FIELDS_DocumentTypeCode: 'Dokumententyp-Code',
    EXTRACTED_FIELDS_MRZDocumentNumberCheckDigit: 'MRZ Prüfziffer',
    EXTRACTED_FIELDS_MRZBirthDateCheckDigit: 'MRZ Geburtsdatum Prüfziffer',
    EXTRACTED_FIELDS_MRZExpiryDateCheckDigit: 'MRZ Ablaufdatum Prüfziffer',
    EXTRACTED_FIELDS_MRZPersonalNumberCheckDigit:
        'MRZ Personalnummer Prüfziffer',
    EXTRACTED_FIELDS_MRZCompositeCheckDigit: 'MRZ Zusammengesetzte Prüfziffer',
    EXTRACTED_FIELDS_SecondaryPortraitPhoto: 'Sekundäres Porträtfoto',
    EXTRACTED_FIELDS_Fingerprint: 'Fingerabdruck',
    EXTRACTED_FIELDS_VersionNumber: 'Versionsnummer',
    EXTRACTED_FIELDS_Conditions: 'Bedingungen',
    EXTRACTED_FIELDS_NickName: 'Spitzname',
    EXTRACTED_FIELDS_AddressApartmentNumber: 'Wohnungsnummer',
    EXTRACTED_FIELDS_AddressFloorNumber: 'Stocknummer',
    EXTRACTED_FIELDS_FirstNameLocal: 'Vorname vor Ort',
    EXTRACTED_FIELDS_LastNameLocal: 'Nachname Lokal',
    EXTRACTED_FIELDS_FullNameLocal: 'Vollständiger Name vor Ort',
    EXTRACTED_FIELDS_BirthPlaceLocal: 'Geburtsort Lokal',
    EXTRACTED_FIELDS_IssuingAuthorityLocal: 'Ausstellungsbehörde vor Ort',
    EXTRACTED_FIELDS_MotherNameLocal: 'Mutter Name Lokal',
    EXTRACTED_FIELDS_FatherNameLocal: 'Vatername Lokal',
    EXTRACTED_FIELDS_AddressFullLocal: 'Adresse Voll Lokal',
    EXTRACTED_FIELDS_MiddleNameLocal: 'Zweiter Vorname Ortsgewohnheit',
    EXTRACTED_FIELDS_AddressLine1Local: 'Adresszeile 1 Lokal',
    EXTRACTED_FIELDS_AddressLine2Local: 'Adresszeile 2 Lokal',
    EXTRACTED_FIELDS_AddressLine3Local: 'Adresszeile 3 Lokal',
    EXTRACTED_FIELDS_IndRefNumber1: 'Individuelle Referenznummer 1',
    EXTRACTED_FIELDS_IndRefNumber2: 'Individuelle Referenznummer 2',
    EXTRACTED_FIELDS_IndRefNumber3: 'Individuelle Referenznummer 3',
    EXTRACTED_FIELDS_IndRefNumber4: 'Individuelle Referenznummer 4',
    EXTRACTED_FIELDS_IndRefNumber5: 'Individuelle Referenznummer 5',
    EXTRACTED_FIELDS_Name1: 'Name 1',
    EXTRACTED_FIELDS_Name2: 'Name 2',
    EXTRACTED_FIELDS_Name3: 'Name 3',
    EXTRACTED_FIELDS_Name4: 'Name 4',
    EXTRACTED_FIELDS_Name5: 'Name 5',
    EXTRACTED_FIELDS_RECIPIENT_NAME_1: 'Empfängername 1',
    EXTRACTED_FIELDS_RECIPIENT_NAME_2: 'Empfängername 2',
    EXTRACTED_FIELDS_RECIPIENT_NAME_3: 'Empfängername 3',
    EXTRACTED_FIELDS_RECIPIENT_NAME_4: 'Empfängername 4',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_FULL: 'Empfängeradresse Vollständig',
    EXTRACTED_FIELDS_IBAN: 'IBAN-Kontonummer',
    EXTRACTED_FIELDS_ACCOUNT_NUM: 'Kontonummer',
    EXTRACTED_FIELDS_ISSUER: 'Aussteller',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_CITY: 'Empfängeradresse Stadt',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_POST_CODE:
        'Empfängeradresse Postleitzahl',
    EXTRACTED_FIELDS_DAY: 'Tag',
    EXTRACTED_FIELDS_MONTH: 'Monat',
    EXTRACTED_FIELDS_YEAR: 'Jahr',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_1: 'Optionaler Wert 1',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_2: 'Optionaler Wert 2',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_3: 'Optionaler Wert 3',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_4: 'Optionaler Wert 4',
    EXTRACTED_FIELDS_ISSUING_STATE_NAME: 'Name des ausstellenden Staates',
    EXTRACTED_FIELDS_FRONT_DOCUMENT_TYPE_ID: 'Dokumenttyp-ID Vorderseite',
    EXTRACTED_FIELDS_BACK_DOCUMENT_TYPE_ID: 'Dokumenttyp-ID Rückseite',
    HASNOCAMERA_TITLE:
        'Ups, wir konnten keine Kamera auf Ihrem Gerät erkennen!',
    HASNOCAMERA_DESCRIPTION:
        'Es sieht so aus, als ob Ihr Gerät keine Kamera hat. Bitte versuchen Sie es mit einem anderen Gerät, das über eine funktionierende Kamera verfügt, damit Sie alle erforderlichen Schritte ausführen können.',
    EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT: 'Covid Type Id',
    USER_INPUT_FIRST_NAME: 'Vorname',
    USER_INPUT_MIDDLE_NAME: 'Zweiter Vorname',
    USER_INPUT_LAST_NAME: 'Nachname',
    USER_INPUT_DOB: 'Geburtsdatum',
    USER_INPUT_HOUSE_NAME_NUMBER: 'Hausname/-nummer*',
    USER_INPUT_STREET_NAME: 'Straßenname*',
    USER_INPUT_TOWN: 'Ort*',
    USER_INPUT_POSTAL_CODE: 'Postleitzahl*',
    USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE: 'z. B. Haus/35',
    USER_INPUT_STREET_NAME_EXAMPLE: 'z. B. Teststraße',
    USER_INPUT_TOWN_EXAMPLE: 'z. B. Irgendwo',
    USER_INPUT_POSTAL_CODE_EXAMPLE: 'z. B. CH496 (ohne Leerzeichen)',
    SYSTEM_NOT_ABLE: 'Das System konnte das Dokument nicht scannen',
    TRY_AGAIN: 'Versuche es erneut',
    HINTS_DISABLED_HEADER: 'Hinweise sind im manuellen Modus deaktiviert',
    HINTS_DISABLED_DESCRIPTION:
        'Wenn du die Hinweise zum Fotografieren aktivieren möchtest, wechsle in den Modus AUTOMATISCHE AUFNAHME',
    YOU_HAVE: 'Du hast',
    PICTURE_VERIFYING: 'Überprüfung läuft...',
    HOW_TO_TAKE_PHOTO_CORRECTLY: 'So machst du ein Foto richtig',
};
